export const CONSONANT_VOWEL_PAIRS_T = [

    // ㅌ
  {
        id: 1,
        korean: "타",
        english: "ta",

    },
    {
        id: 2,
        korean: "테",
        english: "te",

    },
    {
        id: 3,
        korean: "티",
        english: "ti",

    },
    {
        id: 4,
        korean: "토",
        english: "to",

    },
    {
        id: 5,
        korean: "트",
        english: "teu",

    },
    {
        id: 6,
        korean: "터",
        english: "teo",

    },
    {
        id: 7,
        korean: "탸",
        english: "tya",

    },
    {
        id: 8,
        korean: "태",
        english: "tae",

    },
    {
        id: 9,
        korean: "톄",
        english: "tye",

    },
    {
        id: 10,
        korean: "툐",
        english: "tyo",

    },
    {
        id: 11,
        korean: "텨",
        english: "tyeo",

    },
    {
        id: 12,
        korean: "튜",
        english: "tyu",

        

    },

    {
        id: 13,
        korean: "탄",
        english: "tan",

        

    },
    {
        id: 14,
        korean: "탁",
        english: "tak",

        

    },
    {
        id: 15,
        korean: "팀",
        english: "tim",
        

    },
    {
        id: 16,
        korean: "탗",
        english: "tat",
        

    },
    {
        id: 17,
        korean: "탛",
        english: "tah",
        

    },
    {
        id: 18,
        korean: "텁",
        english: "teob",
        

    },
          {
        id: 19,
        korean: "틀",
        english: "teul",
        

    },
    {
        id: 20,
        korean: "탓",
        english: "tat",
        

    },
    {
        id: 21,
        korean: "탞",
        english: "taekk",
        

    },
    {
        id: 22,
        korean: "탠",
        english: "taen",
        

    },
    {
        id: 23,
        korean: "틔",
        english: "tui",
        

    },
    {
        id: 24,
        korean: "퉈",
        english: "two",
        

    },

    {
        id: 25,
        korean: "턋",
        english: "tyat",
        

    },
    {
        id: 26,
        korean: "탖",
        english: "tat",
        

    },
    {
        id: 27,
        korean: "탙",
        english: "tat",
        
    },
    {
        id: 28,
        korean: "잍",
        english: "it",
        
    },
    {
        id: 29,
        korean: "탓",
        english: "tat",
        
    },
    {
        id: 30,
        korean: "탙",
        english: "tat",
        
    },
    
    
    
];

